const dayOffsTypes = [
    "Sick", 
    "Vacation", 
    "Bereavement", 
    "Jury Duty", 
    "Military", 
    "Maternity/Paternity", 
    "Other", 
];

export default dayOffsTypes;